import axiosInstance from "../utils/axiosInstance";
import { businessEnquiriesUrl, businessEnquiryStatusUrl } from "../utils/urls";

export const getBusinessEnquiries = async (page = 1, limit = 10, sortBy = 'status', sortOrder = 'asc') => {
  const res = await axiosInstance.get(businessEnquiriesUrl, {
    params: { page, limit, sortBy, sortOrder },
  });
  return res.data;
};

export const patchBusinessEnquiry = async (id, status) => {
  const res = await axiosInstance.patch(businessEnquiryStatusUrl(id), { status });
  return res.data;
};

export default {
  getBusinessEnquiries,
  patchBusinessEnquiry,
};
